import React from 'react';

import { BrailleInput, BrailleSymbol } from '../../../components';
import { BRAILLE, SYMBOLS, SYMBOLS_LETTERS } from '../../../symbols';
import { convertToDots } from '../../../utilities';
import { verifyDrawAnswer } from '../helpers';

interface DrawWordPreviousProps {
  previousResult: { correct: string; drawnSymbols: BRAILLE[] } | null;
}

const getDotHighlights = (userSymbol: BRAILLE, correctSymbol: BRAILLE): ('correct' | 'incorrect')[] => {
  const userDots = convertToDots(userSymbol);
  const correctDots = convertToDots(correctSymbol);
  return userDots.map((userDot, i) => (userDot === correctDots[i] ? 'correct' : 'incorrect'));
};

export const DrawWordPrevious = ({ previousResult }: DrawWordPreviousProps) => {
  if (previousResult === null) {
    return (
      <>
        <div className="flex justify-center flex-row flex-wrap opacity-0">
          <BrailleSymbol input={SYMBOLS[SYMBOLS_LETTERS]['a'][0]} />
        </div>
        <div className="flex justify-center mb-8 opacity-0">
          <p>Lorem ipsum</p>
        </div>
      </>
    );
  }

  const { correct, drawnSymbols } = previousResult;
  const verified = verifyDrawAnswer({ correctWord: correct, drawnSymbols });

  const allCorrect = verified.every((item) => item.correct);

  return (
    <>
      <div className="flex flex-col items-center opacity-60">
        <div className="flex justify-center flex-row flex-wrap">
          {verified.map((item, index) => (
            <BrailleInput
              key={index}
              value={drawnSymbols[index] ?? 0}
              onChange={() => undefined}
              dotHighlights={getDotHighlights(drawnSymbols[index] ?? 0, item.symbol)}
            />
          ))}
        </div>
        <div className="flex justify-center mb-8">
          <span className={allCorrect ? 'text-green-600' : 'text-red-500'}>{correct}</span>
        </div>
      </div>
    </>
  );
};
